'use strict';

var React = require('react');

module.exports = function (props) {
    return React.createElement('svg', Object.assign({ viewBox: '220 220 584 584' }, props), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M800 640l-288-288-288 288h576z' })
    ));
};